import { configureStore } from "@reduxjs/toolkit";
import { antiqueReducer } from "./slices/antique.slice";
import { furnitureReducer } from "./slices/furniture.slice";
import { housingForSaleReducer } from "./slices/housingForSale.slice";
import { longTermHousingRentalsReducer } from "./slices/longTermHousingRentals.slice";
import { shortTermHousingRentalsReducer } from "./slices/shortTermHousingRentals.slice";

export const store = configureStore({
  reducer: {
    antique: antiqueReducer,
    furniture: furnitureReducer,
    housingForSale: housingForSaleReducer,
    longTermHousingRentals: longTermHousingRentalsReducer,
    shortTermHousingRentals: shortTermHousingRentalsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
